import {helpers} from "@/helpers/index.ts";

const authApis = {
  authValidate: async (params: any = {}, headers: any = {}) => {
    return helpers.api.post({
      data: params,
      headers,
      url: '/auth/validate'
    })
  },
  login: async (params: any, headers: any = {}) => {
    return helpers.api.post({
      data: params,
      headers,
      url: '/login'
    })
  },
  me: async (params: any = {}, headers: any = {}) => {
    return helpers.api.get({
      headers,
      params,
      url: '/me'
    })
  }
};

export default authApis
